module.exports = __webpack_public_path__ + "img/menudata.2c0814a5.png";